import { useState, useEffect } from "react";
import Typography from "../components/v2/Typography";

const default_Image = "https://cdn.webstadia.com/9cbd470e-11c4-483b-a773-b98e364257ee.jpeg";

const services_Links = [
  // {
  //   title: "Domain Brokering",
  //   href: "/services/domain-brokering",
  //   img: "/images/services/domain-broker.jpg"
  // },
  // {
  //   title: "Domain Acquisition",
  //   href: "/services/domain-acquisition",
  //   img: "/images/services/domain-acquisition.jpg"
  // },
  // {
  //   title: "Consultation",
  //   href: "/services/consultation",
  //   img: "/images/services/consultation.jpg"
  // },
  // {
  //   title: "Portfolio Management",
  //   href: "/services/portfolio-management",
  //   img: "/images/services/portfolio.jpg"
  // },
  // {
  //   title: "Discreet Acquisitions",
  //   href: "/services/discreet-acquisitions",
  //   img: "/images/services/discreet.jpg"
  // },
  // {
  //   title: "Marketing & Design",
  //   href: "/services/marketing-design",
  //   img: "/images/services/marketing.jpg"
  // }


  {
    title: "Domain Acquisition",
    href: "/services/domain-acquisition",
    img: "/images/services/acquisiton.jpg"
  },
  {
    title: "Domain Brokering",
    href: "/services/domain-brokering",
    img: "/images/services/domain-broker.jpg"
  },
  {
    title: "Domain Appraisals",
    href: "/services/domain-appraisals",
    img: "/images/services/appraisal.jpg"
  },
  {
    title: "Consulting",
    href: "/services/consulting",
    img: "/images/services/consultation.jpg"
  },
  {
    title: "Strategy",
    href: "/services/strategy",
    img: "/images/services/portfolio.jpg"
  },
  // {
  //   title: "Discreet Acquisitions",
  //   href: "/services/discreet-acquisitions",
  //   img: "/images/services/discreet.jpg"
  // },
  {
    title: "Marketing & Design",
    href: "/services/marketing-design",
    img: "/images/services/marketing.jpg"
  }
];

const ServicesHeader = ({ active }) => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [activeImage, setActiveImage] = useState(null);
  const [defaultImage, setDefaultImage] = useState(default_Image);

  const [preloadedImages, setPreloadedImages] = useState({});

  useEffect(() => {
    const cache = {};
    services_Links.forEach((link) => {
      const img = new Image();
      img.src = link.img;
      img.onload = () => {
        cache[link.img] = img;
        if (Object.keys(cache).length === services_Links.length) {
          setPreloadedImages(cache);
        }
      };
    });
  }, []);

  useEffect(() => {
    if (active) {
      const service = services_Links.find((link) => link.href === active);
      if (service) {
        console.log("Active : ", service);
        setActiveImage(service.img);
      }
    }
    else {
      setActiveImage(null);
    }
  }, [active]);

  return (
    <section className="services-hero-wrapper">
      <div className="inner">
        <div className="hero-heading">
          <Typography variant="h1">Our Services & Solutions</Typography>
        </div>
        <div className="hero-menu">
          <div className="hero-menu-preview">
            <img
              src={hoveredImage || activeImage || defaultImage}
              alt=""
              style={{ transition: "opacity 0.3s", objectFit: "cover", width: "100%", height: "100%" }}
            />
          </div>
          <div className="hero-menu-links">
            <ul className="hero-menu-links-list">
              {services_Links.map((service) => (
                <li
                  key={service.href}
                  onMouseEnter={() => setHoveredImage(service.img)}
                  onMouseLeave={() => setHoveredImage(null)}
                  className={service.href === active ? "active" : ""}
                >
                  <a href={service.href}>
                    <span>
                      <Typography variant="h2">{service.title}</Typography>
                    </span>
                    <span>
                      <ArrowRightCircleCustom />
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const ArrowRightCircleCustom = ({ props }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill={"black"} />
    <path d="M9.99902 14L13.999 10L9.99902 6" stroke="white" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 10H14" stroke="white" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ServicesHeader;
